<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage importers</small>
      </legend>
      <div></div>

      <div>
        <div class="importersLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa spin" style="font-size: 24px; color: blue"></i>loading importers...
        </div>

        <vue-good-table
          :columns="columns"
          :rows="systemImporters"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button v-b-tooltip.hover.bottom="'Edit importer!'"  class="btn btn-primary btn-sm btn-rounded" @click="viewImporter(props.row.id)">
                <i class="fa fa-edit"></i> Edit Importer
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Importer name",
          field: "importer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter importer"
          }
        },
        {
          label: "Email",
          field: "email_address",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter email"
          }
        },
        {
            label: "Address",
            field: "address",
            type: "text",
            filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter address"
          }
        },
        {
            label: "City",
            field: "city",
            type: "text",
            filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter city"
          }
        },
        {
            label: "Phone",
            field: "mobile_number",
            type: "text",
            filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter phone"
          }
        },
        {
          label: "Action",
          field: "Action",
          width: "30px",
          html: true
        }
      ]
    };
  },

  created() {
      this.loadImporter();
  },
  computed: {
      ...mapGetters(["systemImporters"])
  },
  methods: {
      ...mapActions(["loadImporter", "viewImporter"])
  }
};
</script>



// WEBPACK FOOTER //
// src/importers/manageimporters.vue